import { Component } from '@angular/core';
import {ResetDeleteIconService} from './../reset-delete-icon/reset-delete-icon.service';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { StorageService } from '../../../services/storage.service';
import { NotificationService } from '../../../services/notification.service';
interface Icons{
  resetIcon:boolean,
  isDeleteIcon:boolean,
  editIcon:boolean,
  previewIcon:boolean,
  sendIcon:boolean,
  editCreditUser:boolean,
  refreshIcon:boolean,
 }

@Component({
  selector: 'app-reset-delete-icon',
  templateUrl: './reset-delete-icon.component.html',
  styleUrls: ['./reset-delete-icon.component.scss']
})

export class ResetDeleteIconComponent  implements ICellRendererAngularComp {
  public params: ICellRendererParams & Icons;
  // @Input() apiEndpoint: string;
  isDeleteIcon = true;
  editIcon = false;
  getParamasData:any;
  constructor(
    private resetDeleteIconService: ResetDeleteIconService,
    private modalService : NgbModal,
    public storageService : StorageService,
    public notificationService: NotificationService,
){
  }
  agInit(params: ICellRendererParams & Icons): void {
    this.params = params;
    this.isDeleteIcon = params?.isDeleteIcon??true;
    this.editIcon = params?.editIcon??true;
  }
  refresh(): boolean {
    return true;
  }

  deleterowdata(params)
  {
    params.api.deselectAll();
    params.node.setSelected(true);
     const selectedNode = params.api.getSelectedRows();
     this.params.api.applyTransaction({ remove: selectedNode});
     params.api.deselectAll();
     const custoDeleteEvent = new CustomEvent('deleteButtonClick', {
      detail: { data: params },
    });
    this.params.api.dispatchEvent(custoDeleteEvent);
    this.storageService.onDeleteRowClicked.next(params);
  }

  onDeleteClick(params) {
    this.openConfirmationPopupDelete(params);
  }

     openConfirmationPopupDelete(params): void {
        // const modalOption: NgbModalOptions = {
        //   centered: true,
        //   backdrop: "static",
        //   keyboard: false,
        //   size: "sm",
        // };
        //   const modalRef = this.modalService.open(CommonPopupComponent, modalOption);
        //   modalRef.componentInstance.isDeleteConfirm = true;
        //   modalRef.result.then((res) => {
        //    if(res){
        //   this.deleterowdata(params)
        //    }
        //   })

        this.notificationService.confirmationPopup('Deleting', `Are you sure you want to delete this record ?`, 'delete-confirm', false, 'Delete', 'Cancel', true).subscribe((result) => {
      if (result?.isConfirmed) {
      this.deleterowdata(params)
       
      } else if (result?.isDismissed) { }
    });
      }
      

  editrowdata(params){
    const custoDeleteEvent = new CustomEvent('editButtonClick', {
      detail: { data: params },
    });
    this.params.api.dispatchEvent(custoDeleteEvent);
     this.storageService.onEditIconRowClick.next(params);
  }
  onPreviewClick(params){
    const custoDeleteEvent = new CustomEvent('previewIconClick', {
      detail: { data: params },
    });
    this.params.api.dispatchEvent(custoDeleteEvent);
  }

  onDeleteIconClick(params){
     params.api.deselectAll();
    params.node.setSelected(true);
    const custoDeleteEvent = new CustomEvent('deleteButtonClick', {
      detail: { data: params },
    });
    this.params.api.dispatchEvent(custoDeleteEvent);
  }
  onSendIcon(params){
    params.api.deselectAll();
    params.node.setSelected(true);
    const custoDeleteEvent = new CustomEvent('sendButtonClick', {
      detail: { data: params },
    });
    this.params.api.dispatchEvent(custoDeleteEvent);

  }
    editCreditdata(params){
    const custoDeleteEvent = new CustomEvent('editCreditButtonClick', {
      detail: { data: params },
    });
    this.params.api.dispatchEvent(custoDeleteEvent);
  }
  onRefreshClick(params){
    const refreshButtonClick = new CustomEvent('refreshButtonClick', {
      detail: { data: params },
    });
    this.params.api.dispatchEvent(refreshButtonClick);
  }

}
